import React, { } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Space,
  Image,
  Button,
} from '@lockerpm/design';

import {
} from '@ant-design/icons'

import IconLogo from '../../assets/images/logos/icon-logo.svg';
import layoutComponents from '../../components/layout';

import global from '../../config/global';

import '../css/sidebar-top.scss';

function SidebarTop(props) {
  const { DropdownMenu } = layoutComponents;
  const { collapsed } = props;
  const { t } = useTranslation();
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace);

  const handleClickLogo = () => {
    global.navigate('PROJECTS', { workspace_id: selectedWorkspace.id });
  }

  return (
    <div className="admin-layout-sidebar-top">
      <div className='flex items-center'>
        <Space wrap size={64}>
          <Button
            type='text'
            size={'large'}
            icon={
              <Image
                className='icon-logo'
                src={IconLogo}
                preview={false}
              />
            }
            onClick={() => handleClickLogo()}
          />
        </Space>
        {
          !collapsed && <p
            className='ml-1 font-semibold'
          >
            {t('common.app_title')}
          </p>
        }
      </div>
      <DropdownMenu />
    </div>
  );
}

export default SidebarTop;
